import { ProgressionModelView } from '@/components/progression-model/ProgressionModelView';

export default function ProgressionModelContent() {
  return <ProgressionModelView />;
}
